type UncancellableFlowRunState = {
  clearUncancellableFlowRun: (sessionId: string) => void
  markUncancellableFlowRun: (sessionId: string) => void
  uncancellableFlowRunSessionIds: ReadonlyMap<string, number>
}

type UncancellableFlowRunStore = {
  <Selected>(selector: (state: UncancellableFlowRunState) => Selected): Selected
}

/**
 * Tracks the chat sessions whose synchronous REST Flow request is still in
 * flight. Those requests cannot be aborted by the chat transport's Cancel
 * handler, so their composer must not advertise that action.
 */
export function useUncancellableFlowRunSessions(
  explorerStore: UncancellableFlowRunStore,
  currentSessionId: string | null
) {
  const isCurrentSessionUncancellable = explorerStore(
    (state) =>
      currentSessionId !== null && state.uncancellableFlowRunSessionIds.has(currentSessionId)
  )
  const markUncancellableFlowRun = explorerStore((state) => state.markUncancellableFlowRun)
  const clearUncancellableFlowRun = explorerStore((state) => state.clearUncancellableFlowRun)

  return {
    clearUncancellableFlowRun,
    isCurrentSessionUncancellable,
    markUncancellableFlowRun,
  }
}
